<template>
  <div>
    <spinner v-if="loading"></spinner>
    <div v-else class="text-center">
      <p class="text-muted" v-html="$t('Otp.smsSent', {phoneNumber: this.maskedPhoneNumber})"></p>
      <p>{{ $t('Otp.pleaseEnterCode') }}</p>
      <div class="mb-3">
        <div class="form-group text-center">
          <div>
            <input class="form-control form-control-lg form-control-otp"
                   :class="{'is-invalid': this.otpVerificationError}"
                   id="otp-code-input"
                   ref="otp" maxlength="4" v-model="otpCode" v-mask="'####'" inputmode="numeric" v-focus/>
            <span v-if="this.otpVerificationError"
                  class="invalid-feedback ml-n2 mt-3" id="otp-code-error">{{ $t('Otp.incorrectOtp') }}</span>
          </div>
        </div>
      </div>
      <div class="font-weight-bold text-tabular-numbers text-muted-more">{{ minutes }}:{{ seconds }}</div>
      <div :style="{visibility: loginInProcess ? 'visible' : 'hidden'}" class="mb-2">
        <span id="loading-spinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>
      <div :style="{visibility: remainingTimeInSeconds < 150 ? 'visible' : 'hidden'}">
        <button class="btn btn-secondary btn-sm rounded-pill" @click="resend">{{ $t('Otp.resend') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '@aws-amplify/auth'

export default {
  name: 'Otp',
  components: {},
  props: ['pin', 'signingHash'],
  data() {
    return {
      otpCode: '',
      cognitoUser: null,
      loginInProcess: false,
      maskedPhoneNumber: null,
      otpVerificationError: false,
      loading: true,
      remainingTimeInSeconds: 0,
      countDownInterval: null
    }
  },
  mounted() {
    this.initializeSignIn(this.pin)
    this.$watch('otpCode', this.verifyOtp)
  },
  beforeDestroy() {
    clearInterval(this.countDownInterval)
  },
  methods: {
    initializeSignIn(customerPin) {
      this.loading = true
      this.remainingTimeInSeconds = 180
      this.maskedPhoneNumber = null

      Auth.signIn(customerPin)
          .then(res => {
            this.cognitoUser = res
            this.maskedPhoneNumber = res.challengeParam.maskedPhoneNumber
            this.loading = false
            this.startCountDown()
          })
          .catch((e) => {
            console.log(`[otp] auth failed: ${e}`)
            this.$errorToast(this.$t('errors.technical.title'), this.$t('errors.technical.content'))
            this.$router.back()
          })
    },

    verifyOtp() {
      if (this.otpCode.length === 4) {
        this.loginInProcess = true
        this.otpVerificationError = false
        this.$refs.otp.blur()
        const tokenClaims = { otp_code: this.otpCode }
        if (this.signingHash) {
          tokenClaims.sign_meta_data = this.signingHash
        }
        Auth.sendCustomChallengeAnswer(this.cognitoUser, this.otpCode, tokenClaims)
            .then(this.checkCognitoResponse)
            .catch(this.verificationFailed)
      }
    },

    checkCognitoResponse({ signInUserSession }) {
      if (!signInUserSession) {
        throw new Error('User authentication failed')
      } else {
        clearInterval(this.countDownInterval)
        this.$emit('otp-success')
      }
    },

    verificationFailed(err) {
      if (err.code === 'UserLambdaValidationException') {
        this.maxRetriesExceeded()
      }

      this.loginInProcess = false
      this.otpVerificationError = true
      this.otpCode = ''
      this.$refs.otp.focus()
    },

    maxRetriesExceeded() {
      console.log('[otp] otp retries exceeded')
      this.$errorToast(this.$t('errors.otpMaxRetriesExceeded.title'), this.$t('errors.otpMaxRetriesExceeded.content'))
      this.$router.back()
    },

    remainingTimeOver() {
      console.log('[otp] otp remaining time over')
      this.$errorToast(this.$t('errors.remainingTimeOver.title'), this.$t('errors.remainingTimeOver.content'))
      this.$router.back()
    },

    startCountDown() {
      this.countDownInterval = setInterval(this.handleCountDown, 1000)
    },

    handleCountDown() {
      if (this.remainingTimeInSeconds > 0) {
        this.remainingTimeInSeconds--
      } else {
        clearInterval(this.countDownInterval)
        this.remainingTimeOver()
      }
    },

    resend() {
      clearInterval(this.countDownInterval)
      this.initializeSignIn(this.pin)
    }
  },
  computed: {
    minutes() {
      return '0' + Math.floor(this.remainingTimeInSeconds / 60)
    },
    seconds() {
      const seconds = this.remainingTimeInSeconds % 60
      return seconds < 10 ? '0' + seconds : seconds
    }
  }
}
</script>
